import styled from '@emotion/styled';
import { size, space } from '../../styles';
import { buildCSSWithLength } from '../../styles';
import { StackAlignment, StackProps } from './types';

export type HorizontalAlignment = 'stretch' | 'leading' | 'trailing' | 'center';

const STACK_ALIGNMENT_BY_HORIZONTAL_ALIGNMENT: Record<HorizontalAlignment, StackAlignment> = {
  stretch: 'stretch',
  leading: 'flex-start',
  trailing: 'flex-end',
  center: 'center',
};

export interface VStackProps extends StackProps {
  alignment?: HorizontalAlignment;
}
/**
 * @deprecated Stack을 사용해주세요
 */
export const VStack = styled.div<VStackProps>`
  display: flex;
  flex-direction: column;
  ${({ alignment }) => alignment !== undefined && `align-items: ${STACK_ALIGNMENT_BY_HORIZONTAL_ALIGNMENT[alignment]}`};

  ${size};
  ${space};

  ${({ spacing }) => {
    switch (spacing) {
      case undefined:
        return '';
      case 'auto':
        return 'justify-content: space-between;';
      default:
        return buildCSSWithLength('row-gap', spacing);
    }
  }}
`;
